import { render, staticRenderFns } from "./LoadQuoteSteps.vue?vue&type=template&id=856070b4"
import script from "./LoadQuoteSteps.vue?vue&type=script&lang=js"
export * from "./LoadQuoteSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('856070b4')) {
      api.createRecord('856070b4', component.options)
    } else {
      api.reload('856070b4', component.options)
    }
    module.hot.accept("./LoadQuoteSteps.vue?vue&type=template&id=856070b4", function () {
      api.rerender('856070b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/components/LoadQuoteSteps/LoadQuoteSteps.vue"
export default component.exports